const Constants = {
  PAYMENT_METHOD_LOOKUP: new Map([
    ['bank', 'Chuyển khoản'],
    ['cod', 'Tiền mặt'],
    ['partner', 'Đại diện'],
    ['gift', 'Quà tặng'],
    ['prepaid', 'Thanh toán trước'],
    ['award', 'Thưởng'],
  ]),
  STATUS_LOOKUP: new Map([
    ['placed', 'Đặt hàng'],
    ['confirmed', 'Đã chốt'],
    ['shipping', 'Đang vận chuyển'],
    ['paid', 'Đã thanh toán'],
    ['given', 'Miễn phí'],
    ['gift', 'Quà tặng'],
    ['prepaid', 'Thanh toán trước'],
    ['award', 'Thưởng'],
    ['cancel', 'Đã huỷ'],
  ]),
};

export default Constants;



// WEBPACK FOOTER //
// ./src/utils/Constants.js